module.exports = __webpack_public_path__ + "static/img/3_1_3.21ca57fa.jpg";